export const defaultBody = (data: any) => {
  return {
    data,
    jsonapi: {},
  }
}
